// import md5 from 'js-md5'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './api/config'
import VueAxios from 'vue-axios'
import { Form, Input, FormItem, Upload, Row, Col, Button, Message, DatePicker, Radio, Checkbox, RadioGroup, Select, Option, Tooltip, Dialog, Loading, Alert, Carousel, CarouselItem, MessageBox, Pagination, Tabs, TabPane, Table, TableColumn, Link } from 'element-ui'
import Clickoutside from 'element-ui/src/utils/clickoutside'
// import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont.js'
import './assets/styles/reset.css'
import './assets/styles/custom.css'
import '@/api/config'
Vue.config.productionTip = false
Vue.use(Form)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Upload)
Vue.use(Row)
Vue.use(Col)
Vue.use(Button)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(RadioGroup)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Alert)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Link)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm;
Vue.directive('clickoutside', Clickoutside)
// Vue.use(Element)
Vue.use(VueAxios, axios)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
// 加入百度统计
router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})
